import React from 'react'

import { Link, useLocation, useRouteMatch } from 'react-router-dom'

import { HeaderBackButton } from '@components/UI/TitleBar'
import { PageRoutes, PCRChannels } from '@enums'
import { selectCampaignId } from '@store/router'
import Theme from '@theme'
import { objectToQueryString, queryStringtoObject } from '@utils'

export interface IInternalProps {
  campaignId: number
  search: string
}

export const getRedirectLink = (search, campaignId) => {
  const searchParams = queryStringtoObject(search)
  if (searchParams && searchParams.from) {
    const { from: searchParamsFrom, ...otherSearchParams } = searchParams
    if (Object.values(PCRChannels).includes(searchParamsFrom)) {
      return `/campaigns/${campaignId}/reports/pcr?channel=${searchParamsFrom}`
    }
    if (searchParams.filter || searchParams.sort_by) {
      return {
        pathname: decodeURIComponent(searchParamsFrom),
        search: objectToQueryString(otherSearchParams),
      }
    }
    return decodeURIComponent(searchParamsFrom)
  }

  const queryObject = { ...searchParams, from: undefined, fromPageRoute: PageRoutes.Submissions }
  return {
    pathname: `/campaigns/${campaignId}`,
    search: objectToQueryString(queryObject),
  }
}

const TitleBarDesktopBackButton: React.FC = () => {
  const match = useRouteMatch()
  const location = useLocation()
  const campaignId = selectCampaignId(match)
  const search = location.search

  return (
    <Link to={getRedirectLink(search, campaignId)}>
      <HeaderBackButton
        glyph="nav-back-default"
        size={1.5}
        color={Theme.grey900Color}
        data-cy-element="header-back-button"
      />
    </Link>
  )
}

export { TitleBarDesktopBackButton }
export default TitleBarDesktopBackButton
